import { makeRequest } from "./general";

const apiPublicUrl = window.apiPublicUrl;
export default class PublicServices {
  constructor() {
    this.baseUrl = apiPublicUrl;
  }

  async getDepartamentosLocalidades() {
    const url = `${this.baseUrl}/api/PublicServices/DepartamentosLocalidades`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }

  async getAgenciasRedPagos() {
    const url = `${this.baseUrl}/api/PublicServices/AgenciasRedPagos`;
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await makeRequest(url, params);
  }
}
